/**
 * Timeline hooks — Phase B.
 *
 * The timeline is a unified read of two sources:
 *   - `comments` (user-authored discussion)
 *   - `activity_log` (system events from PO + shipment + supplier handlers)
 * The backend's `listTimeline` returns them already merged and sorted by
 * `created_at` ascending. Mutations invalidate the same query key.
 */
import { trpc } from '@/lib/trpc';

type EntityType = 'purchase_order' | 'product_dev' | 'shipment';

export function useTimeline(entityType: EntityType, entityId: string | undefined) {
  return trpc.comments.listTimeline.useQuery(
    { entityType, entityId: entityId ?? '' },
    {
      enabled: Boolean(entityId),
      staleTime: 15_000,
    },
  );
}

export function useCommentMutations(entityType: EntityType, entityId: string | undefined) {
  const utils = trpc.useUtils();
  const invalidate = () => {
    if (entityId) {
      void utils.comments.listTimeline.invalidate({ entityType, entityId });
    }
  };

  const addComment = trpc.comments.addComment.useMutation({
    onSuccess: invalidate,
  });

  const editComment = trpc.comments.editComment.useMutation({
    onSuccess: invalidate,
  });

  const deleteComment = trpc.comments.deleteComment.useMutation({
    onSuccess: invalidate,
  });

  return { addComment, editComment, deleteComment };
}
